"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "nalles": {
    "cbdc943a": [{
      "hkey": "9f3681ea",
      "slug": "nalles",
      "name": "Nalles",
      "primary": true,
      "skipSearch": false
    }],
    "sirmiano": [{
      "hkey": "9f3681ea",
      "slug": "nalles",
      "name": "Nalles",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;